import { Email, Phone } from "@mui/icons-material";
import type { ProfileDisplayProps } from "../types";
import { useTranslation } from "react-i18next";

const ProfileDisplay: React.FC<ProfileDisplayProps> = ({ phoneNumber, emailAddress }) => {
	const { t } = useTranslation();
	return (
		<>
			<div className="flex items-center bg-[#F7F9FB] rounded-xl px-4 py-3">
				<Phone className="w-6 h-6 mr-3 text-gray-700" />
				<span className="text-lg text-gray-900">{phoneNumber || t("psdaCommon.common.notAvailable")}</span>
			</div>

			<div className="flex items-center bg-[#F7F9FB] rounded-xl px-4 py-3">
				<Email className="w-6 h-6 mr-3 text-gray-700" />
				<span className="text-lg text-gray-900">{emailAddress || t("psdaCommon.common.notAvailable")}</span>
			</div>
		</>
	);
};

export default ProfileDisplay;
